import * as React from "react";
import type { SVGProps } from "react";
const SvgEkpDownload = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M4.6 21.208a.62.62 0 0 1-.619.616h-.615a1.85 1.85 0 0 1-1.85-1.847v-3.701a.62.62 0 0 1 .616-.617.62.62 0 0 1 .618.617v3.701c0 .339.275.616.616.616h.615c.34 0 .619.275.619.615m17.261-5.549a.62.62 0 0 0-.618.617v3.701a.616.616 0 0 1-.616.616H7.065a.615.615 0 1 0 0 1.231h13.562a1.85 1.85 0 0 0 1.852-1.847v-3.701a.62.62 0 0 0-.618-.617m-9.865 1.49 4.136-4.136a.616.616 0 1 0-.872-.872l-2.645 2.647V2.713a.618.618 0 0 0-1.235 0v12.075l-2.647-2.647a.62.62 0 0 0-.871 0 .613.613 0 0 0 0 .872z"
        />
    </svg>
);
export default SvgEkpDownload;
